import { USER_ROLE_TYPES } from '_constants';

// Who may edit a visit — the rule behind the visit page's Edit button, shared with anything else that
// leads to the Edit Visit page (the Notes section's edit pencils), so the two can never disagree.
// Pass both to HasAccess / AccessControl with PERMISSIONS.CHANGE_VISIT.

const { MULTI_ACCOUNT_MANAGER, ACCOUNT_MANAGER, AGENCY_MANAGER, CAMPAIGN_MANAGER, DATA_COLLECTOR } = USER_ROLE_TYPES;

export const VISIT_ROLE_RULE_SET = {
  assigned: [DATA_COLLECTOR],
  agency: [AGENCY_MANAGER],
  agencySecGeogs: [CAMPAIGN_MANAGER],
  all: [ACCOUNT_MANAGER, MULTI_ACCOUNT_MANAGER],
};

/** The visit facts the role rules check: its relationships, geographies and data collector. */
export const visitPermissionData = (entityData) => {
  const relationships = entityData?.data?.relationships;
  const visitCreatorId = relationships?.user?.data?.id;
  return {
    ...relationships,
    secGeog: entityData?.data?.attributes?.aggregationpolygon_set?.map((polygon) => `${polygon}`),
    data_collector: visitCreatorId && [visitCreatorId],
  };
};
